import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const SortDesc = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="sort descending icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4L0 20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0L4 0ZM8.5 4C9.32843 4 10 4.67157 10 5.5V18.5C10 19.1067 9.63454 19.6536 9.07403 19.8858C8.51351 20.118 7.86834 19.9897 7.43934 19.5607L3.43934 15.5607C2.85355 14.9749 2.85355 14.0251 3.43934 13.4393C4.02513 12.8536 4.97487 12.8536 5.56066 13.4393L7 14.8787V5.5C7 4.67157 7.67157 4 8.5 4ZM13.5 5C12.6716 5 12 5.67157 12 6.5C12 7.32843 12.6716 8 13.5 8H19.5C20.3284 8 21 7.32843 21 6.5C21 5.67157 20.3284 5 19.5 5H13.5ZM12 12C12 11.1716 12.6716 10.5 13.5 10.5H16.5C17.3284 10.5 18 11.1716 18 12C18 12.8284 17.3284 13.5 16.5 13.5H13.5C12.6716 13.5 12 12.8284 12 12ZM15 17.5C15 18.3284 14.3284 19 13.5 19C12.6716 19 12 18.3284 12 17.5C12 16.6716 12.6716 16 13.5 16C14.3284 16 15 16.6716 15 17.5Z"
    />
  </svg>
)
